import { responseInterceptor } from '.';

export const userRedeemToken = async (token: string, org: string): Promise<{ jwt: string }> => {
  const params = new URLSearchParams({
    token,
    org,
  });

  const response = await responseInterceptor(
    await fetch(
      // do not use buildAPIUrl here since this is called in the auth callback where we don't have access to req, and buildAPIUrl requires req to build the URL on server side
      `${process.env.NEXTAUTH_URL}/api/services/integration/users/redeemToken?${params.toString()}`,
    ),
  );

  if (response.ok) {
    return response.json();
  } else {
    const errorText = await response.text();
    throw new Error(`Failed to redeem token Status: ${response.status}; error: ${errorText}`);
  }
};
